import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "generate" }
const _hoisted_2 = { class: "generate-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, "请选择本次推广的商品")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-youjiantou" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tianjia" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "创建新的商品AI视频模型", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, "请选择视频生成数量")
], -1)
const _hoisted_11 = { class: "generate-left-numBtn" }
const _hoisted_12 = { class: "btnbox" }
const _hoisted_13 = { class: "customBtn" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "自定义生成数量：", -1)
const _hoisted_15 = { class: "generate-left-btn" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("立即生成")
const _hoisted_17 = { class: "generate-right" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, "AI商品视频生成")
], -1)
const _hoisted_19 = { class: "generate-right-img" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dd", null, "AI 助力快速、低成本生成大量商品推广视频", -1)
const _hoisted_22 = { class: "videoBo" }
const _hoisted_23 = ["src"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "selectShop" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h5", null, "选择已有商品AI视频模型", -1)
const _hoisted_27 = { class: "mt-4" }
const _hoisted_28 = { class: "item-bigBox" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("暂无商品AI视频模型")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("训练中...")
const _hoisted_31 = { class: "iconThreeDiv" }
const _hoisted_32 = { class: "createBtn" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tianjia" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 创建商品AI视频模型")
const _hoisted_35 = { class: "videoShow" }
const _hoisted_36 = { class: "ExportBox" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-daochu" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("批量导出")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_41 = {
  class: "exporyAllBox",
  id: "exporyAllBox"
}
const _hoisted_42 = { class: "btnBox" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("直接导出")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("匹配文案导出")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("再想想")
const _hoisted_46 = { class: "checkedBox" }

import { computed, onMounted, reactive, ref, watch } from "vue";
import { Search } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import Api from "@/api";
import exportVideo from "../../components/video/ExportVideo.vue";
import AnimatonBox from "../../components/video/Animation.vue";
import { ElMessage } from "element-plus";
import { ResponseType } from "axios";
import request from "@/api/httpDown";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogTableVisible = ref(false);
const chheckedArr = ref([]); //复选框的选中下标

const exchange = ref();
const store = useStore();
const input1 = ref("");
const input3 = ref("");
const checkboxAll = ref(true);
const animationShow = ref(false);
const bigImgShow = ref(true);
const isChecked = ref(false);
const checkAll = ref([]);
const exportAllId = ref([]); //批量导出数组id
const valueName = ref("");
const isCheckedAll = ref(false); //复选框选中状态
const inputMsg = ref("输入商品名称,搜索已创建的商品AI视频模型");
const shop = reactive({
  shopName: [],
  shopNameTwo: [],
  nameArr: [],
  numBtn: ["1", "5", "10"],
  count: "",
  videoArr: [],
  detail: {},
});

let selectVideoList = computed(() => {
  let arr = [];
  shop.videoArr.forEach((i) => {
    if (exportAllId.value.includes(i._id)) {
      arr.push(i);
    }
  });
  return arr;
});
const idArr = ref([]); //存放导出id
const isPlay = ref(false);
const inputShow = ref();
const updataId = ref("");
const alertShow = ref(false);
const videoRefs = ref<HTMLElement[]>([]);
const createDisabled = ref(false);
const inputChange = (value) => {
  if (value > 10) {
    alertShow.value = true;
    createDisabled.value = true;
  }
  setTimeout(() => {
    alertShow.value = false;
  }, 5000);
};

watch(
  () => shop.count,
  (newValue, oldValue) => {
    if (newValue <= 10) {
      createDisabled.value = false;
    }
  }
);

onMounted(() => {
  getcostFn();
});
const getcostFn = () => {
  let result = Api.Statistics.getcost();
};

//鼠标进入
const inputIn = () => {
  inputMsg.value = "输入商品名称";
};
//鼠标移出
const inputOut = () => {
  inputMsg.value = "输入商品名称,搜索已创建的商品AI商品模型";
};

//输入框输入事件模糊查询
const inputValue = (e: string) => {
  // eslint-disable-next-line no-use-before-define
  searchFn(e);
};

//模糊查询
const searchFn = (e: string) => {
  // input3.value=e
  let showArr: never[] = [];

  if (e) {
    shop.shopNameTwo.forEach((v) => {
      let index = v.name.indexOf(e);

      if (index !== -1) {
        showArr.push(v);
      }
    });
  } else {
    shop.shopNameTwo.forEach((v) => {
      let index = v.name.indexOf(input3.value);

      if (index !== -1) {
        showArr.push(v);
      }
    });
  }

  shop.shopName = showArr;
  // input3.value = '';
};

//删除商品
const deleteShopName = async (id, index) => {
  shop.shopName.splice(index, 1);
  // let result=await Api.Resource.deleteAi({ resourceId: id});
  let result = await Api.Resource.deleteAi(id);

  getListFn();
};
//向上一级
const toTop = async (index: string, id: string) => {
  let obj = shop.shopName.filter((v, i) => i == index)[0]; //shop。nameShop是原数据
  let detailIndex = shop.shopName.splice(index, 1); //detaiIndex[0]是当前点击的数据

  shop.shopName.unshift(detailIndex[0]);

  let result = await Api.Resource.upDataAi({
    sort: shop.shopName.map((a, i) => ({ resourceId: a.id, sort: i })),
  });

  getListFn();
};
//修改商品
const updataDetail = (v: object) => {
  store.commit("comShow/upDataShow", "Upload");

  sessionStorage.setItem(
    "detailObj",
    JSON.stringify({ detail: v, type: "updata" })
  );
  // updataId.value = id;//修改商品的id
  // inputShow.value = index;
  // valueName.value = shop.shopName[index].name;
  // inputRefs.value[index].focus();
};
//聚焦事件
// const setInputRef = (el: HTMLElement) => {
//     if (el) {
//         inputRefs.value.push(el);
//     }
// };

//input失焦修改
const updataValueBlur = async (e: string) => {
  let val = e.target.value;
  let result = shop.shopNameTwo.findIndex((v) => {
    return v.name === valueName.value;
  });

  if (result === -1) {
    //没有重复的名字  可以修改
    let result = await Api.Resource.upDataAi({
      resourceId: updataId.value,
      productName: val,
    });

    ElMessage({
      message: "修改成功",
      type: "success",
    });
    getListFn();
  } else {
    ElMessage({
      message: "已有该输入商品模型，请更换命名",
      type: "error",
    });
  }
  inputShow.value = "";
};

//确认导出点击事件
const yesExporyAll = () => {
  if (exportAllId.value.length === 0) {
    ElMessage({
      message: "需要选中视频",
      type: "warning",
    });
    return false;
  }
  checkboxAll.value = false;
  isChecked.value = true;
};

//取消导出点击事件
const noExporyAll = () => {
  isChecked.value = false;
  checkboxAll.value = true;
  isCheckedAll.value = false;
  checkAll.value = [];
};

//批量导出
const exportAll = () => {
  checkboxAll.value = false;
};
//点击关闭弹框
const onCloseProp = () => {
  checkboxAll.value = true;
  isChecked.value = false;
  checkboxAll.value = true;
  isCheckedAll.value = false;
  checkAll.value = [];
};
//直接导出
const directExport = async () => {
  isChecked.value = false;
  checkboxAll.value = true;
  ElMessage({
    dangerouslyUseHTMLString: true,
    type: "warning",
    message: "<p>正在下载</p>",
    duration: 1000,
  });

  await request
    .get("/api/cemeta/aimanager/v1/video/result/download", {
      params: {
        videoId: exportAllId.value,
        type: "video_assistant_download_video",
      },
    })
    .then((response) => {
      // 从响应头中获取文件名
      const contentDisposition = response.headers["content-disposition"];
      // const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      let filename = contentDisposition.split("=")[1];
      // 创建一个兼容不同浏览器的 URL 对象
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // 创建一个<a>标签，并设置其下载属性和链接
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", filename);

      // 在DOM中模拟点击下载链接
      document.body.appendChild(link);
      link.click();

      // 清理URL对象
      window.URL.revokeObjectURL(url);

      request.post("/api/cemeta/aimanager/v1/video/download", {
        resourceId: shop.nameArr.id,
        videoUrlList: selectVideoList.value.map((i) => i.result.video),
      });
    })
    .catch((error) => {
      // 处理错误
    });
  ElMessage({
    dangerouslyUseHTMLString: true,
    type: "success",
    message: "<p>下载完成</p>",
    duration: 1000,
  });
  isChecked.value = false;
  checkboxAll.value = true;
};
//

// const videoDownFn=async()=>{
//     await request.get('/api/cemeta/aimanager/v1/file/download', { params: { type: 'oss', url: 'https://demo-product-image-1313090634.cos.ap-beijing.myqcloud.com/task_64e99eaafae920abee15c8aa/image/1693032151317.png' } })
//         .then(response => {
//             // 从响应头中获取文件名
//             const contentDisposition = response.headers['content-disposition'];
//             // const filenameMatch = contentDisposition.match(/filename="(.+)"/);
//             let filename = contentDisposition.split('=')[1];
//             // 创建一个兼容不同浏览器的 URL 对象
//             const url = window.URL.createObjectURL(new Blob([response.data]));

//             // 创建一个<a>标签，并设置其下载属性和链接
//             const link = document.createElement('a');

//             link.href = url;
//             link.setAttribute('download', filename);

//             // 在DOM中模拟点击下载链接
//             document.body.appendChild(link);
//             link.click();

//             // 清理URL对象
//             window.URL.revokeObjectURL(url);
//         });
// };

// videoDownFn()

//匹配文案导出
const mateExport = async () => {
  ElMessage({
    dangerouslyUseHTMLString: true,
    type: "success",
    message: "<p>正在导出，请稍等</p>",
  });
  checkboxAll.value = true;
  isChecked.value = false;
  // let result = await Api.Video.videoDown(['64e71505c1be074f29c862e4'], 'video_assistant_download_video_with_article');""
  await request
    .get("/api/cemeta/aimanager/v1/video/result/download", {
      params: {
        videoId: idArr.value,
        type: "video_assistant_download_video_with_article",
      },
    })
    .then((response) => {
      // 64e71505c1be074f29c862e4
      // 从响应头中获取文件名
      const contentDisposition = response.headers["content-disposition"];
      // const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      let filename = contentDisposition.split("=")[1];
      // 创建一个兼容不同浏览器的 URL 对象
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // 创建一个<a>标签，并设置其下载属性和链接
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", filename);

      // 在DOM中模拟点击下载链接
      document.body.appendChild(link);
      link.click();

      // 清理URL对象
      window.URL.revokeObjectURL(url);
      ElMessage({
        dangerouslyUseHTMLString: true,
        type: "success",
        message: "<p>导出成功</p>",
      });
    })
    .catch((err) => {
      ElMessage({
        dangerouslyUseHTMLString: true,
        type: "error",
        message: "<p>导出失败</p>",
        duration: 5000,
      });
      return false;
    });
};
//再想想
const noExport = () => {
  isChecked.value = false;
  checkboxAll.value = true;
};

//点击复选框
const upDataCheck = (index: string, value) => {
  // isChecked.value=true;
  let result = checkAll.value.findIndex((v) => {
    return v === index;
  });

  if (result === -1) {
    checkAll.value.push(index);
    idArr.value.push(value._id);
    // console.log(shop.videoArr[index]);
    exportAllId.value.push(shop.videoArr[index]._id);
  } else {
    checkAll.value.splice(result, 1);
    exportAllId.value.splice(result, 1);
    idArr.value.splice(result, 1);
  }
};

//获取ai资源
const getListFn = async () => {
  const result = await Api.Video.lookAilist("product_video");

  shop.shopName = result.data;
};
const getListFn1 = async () => {
  const result = await Api.Video.lookAilist("product_video");

  shop.shopNameTwo = result.data;
};
const exports = ref();
const showVideoFn = (v) => {
  exchange.value = true;
  shop.detail = v;
};

onMounted(() => {
  getListFn();
  getListFn1();
});

const upProps = (boolean: boolean) => {
  exchange.value = boolean;
};

//查询视频
const searchVideo = async () => {
  animationShow.value = true;
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  let result = await Api.Video.getVideo({
    resourceId: shop.nameArr.id,
    type: "video_assistant",
    count: shop.count * 1,
    // deadline: formattedDate,
  });

  if (result.data) {
    let flag = result.data.some((v) => {
      return v.result.video !== null;
    });
    if (flag) {
      ElMessage({
        message: "视频生成成功",
        type: "success",
      });
      //有成功的
      animationShow.value = false;

      shop.videoArr = result.data;
    } else {
      setTimeout(() => {
        ElMessage({
          message: "正在生成视频，请稍等",
          type: "warning",
          duration: 9000,
        });
        searchVideo();
      }, 30000);
    }
  }
};

//视频生成结果下载
const videoDown = async () => {
  let result = await Api.Video.videoDown(
    ["xen9ilvj5c"],
    "video_assistant_download_video_with_article"
  );
};

//立即生成视频
const createvideo = () => {
  if (shop.nameArr?.id && shop.count) {
    animationShow.value = true;
    const timer = 5000;
    if (shop.count == 1) {
      timer = 7000;
    } else if (shop.count > 1 && shop.count <= 5) {
      timer = 12000;
    } else {
      timer = 30000;
    }
    console.log(timer);
    setTimeout(() => {
      // animationShow.value = true;
      fn();
    }, timer);
  } else {
    ElMessage({
      type: "error",
      message: "请选择商品视频和数量",
    });
  }
};

const fn = async () => {
  bigImgShow.value = false;

  // animationShow.value = true;
  let result = await Api.Video.createVideo(shop.nameArr.id, shop.count * 1);
  // let result = await Api.Video.createVideo(shop.nameArr.id, (shop.count)*1);

  animationShow.value = false;
  // videoDown();
  searchVideo();
};

//跳转上传页面 清楚点击修改传的参数
const updataShow = () => {
  // store.state.comShow = 'Upload';
  store.commit("comShow/upDataShow", "Upload");
  sessionStorage.removeItem("detailObj");
};
//点击数量按钮
const setCount = (v: string) => {
  shop.count = v;
  input1.value = "";
};
//输入框修改数量
const setInputCount = () => {
  shop.count = input1.value;
};

const selectTitle = () => {
  dialogTableVisible.value = true;
};
//进入页面直接获取商品ai

getListFn();

//选择商品
const selectShop = (item: any, event: Event) => {
  // event.preventDefault();
  shop.nameArr = item;
  dialogTableVisible.value = false;
  getListFn();
  input3.value = "";
};
//商品选择框关闭事件
const seleceShopNo = () => {
  getListFn();
  input3.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_font = _resolveComponent("font")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "generate-left-listBox",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectTitle()))
        }, [
          (_unref(shop).nameArr?.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(shop).nameArr.name), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, "选择已有商品AI视频模型")),
          _hoisted_6
        ]),
        _createElementVNode("div", {
          class: "generate-left-imgBox",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updataShow()))
        }, _hoisted_9),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shop).numBtn, (v, i) => {
              return (_openBlock(), _createBlock(_component_el_button, {
                color: _unref(shop).count == v ? '#626aef' : '',
                onClick: ($event: any) => (setCount(v)),
                plain: "",
                key: i
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(v), 1)
                ]),
                _: 2
              }, 1032, ["color", "onClick"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_input, {
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (setInputCount())),
              modelValue: input1.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (input1.value = $event)),
              modelModifiers: { number: true },
              class: "w-50 m-2",
              size: "large",
              placeholder: "请输入...",
              onInput: inputChange,
              oninput: "if(value){value=value.replace(/[^\\d]/g,'')} if(value<=0){value=''} if(value>20){value=20}"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(alertShow.value ? 'alertRed' : 'alertfff')
        }, " 一次生成任务仅限制生成 10 条或以内数量视频 ", 2),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: createvideo,
            disabled: createDisabled.value
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("dl", null, [
            _createElementVNode("dt", null, [
              _createElementVNode("img", {
                src: require('../../assets/image/generateRight.png'),
                alt: ""
              }, null, 8, _hoisted_20)
            ]),
            _hoisted_21
          ], 512), [
            [_vShow, bigImgShow.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shop).videoArr, (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "videoBoItem",
                key: i
              }, [
                (!checkboxAll.value)
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      onChange: ($event: any) => (upDataCheck(i, v)),
                      size: "large"
                    }, null, 8, ["onChange"]))
                  : _createCommentVNode("", true),
                _createElementVNode("video", {
                  ref: (_value, _refs) => {
                    _refs['videoRefs'] = _value
                    videoRefs.value = _value
                  },
                  id: "video1",
                  src: v.result.video,
                  autoplaymutedcontrolscontrolsList: "nodownload"
                }, null, 8, _hoisted_23),
                _createElementVNode("div", {
                  class: _normalizeClass(!checkboxAll.value ? 'propsBigD' : 'propsBigD propsBigHover')
                }, [
                  _createElementVNode("i", {
                    onClick: ($event: any) => (checkboxAll.value ? showVideoFn(v) : null),
                    class: "iconfont icon-bofang"
                  }, null, 8, _hoisted_24)
                ], 2)
              ]))
            }), 128))
          ], 512), [
            [_vShow, _unref(shop).videoArr.length]
          ])
        ], 512), [
          [_vShow, !animationShow.value]
        ]),
        _withDirectives(_createVNode(AnimatonBox, null, null, 512), [
          [_vShow, animationShow.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_el_dialog, {
          width: "700px",
          modelValue: dialogTableVisible.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (dialogTableVisible.value = $event)),
          onClose: seleceShopNo
        }, {
          default: _withCtx(() => [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_input, {
                onFocus: inputIn,
                onInput: inputValue,
                onBlur: inputOut,
                modelValue: input3.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (input3.value = $event)),
                placeholder: inputMsg.value,
                class: ""
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    onClick: searchFn,
                    type: "info",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Search))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_28, [
                (!_unref(shop).shopName.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_29
                    ], 64))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(shop).shopName, (v, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "el-dialog-item",
                        key: i
                      }, [
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (v.active ? selectShop(v) : ''),
                          disabled: v.active ? false : true
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("p", null, _toDisplayString(v.name), 513), [
                              [_vShow, inputShow.value !== i]
                            ]),
                            _withDirectives(_createVNode(_component_el_input, {
                              ref: _ctx.setInputRef,
                              onBlur: updataValueBlur,
                              modelValue: v.name,
                              "onUpdate:modelValue": ($event: any) => (v.name = $event),
                              modelModifiers: { stop: true }
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
                              [_vShow, inputShow.value === i]
                            ]),
                            _withDirectives(_createVNode(_component_font, null, {
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 2
                            }, 1536), [
                              [_vShow, !v.active]
                            ]),
                            _withDirectives(_createElementVNode("p", _hoisted_31, [
                              _createVNode(_component_el_icon, {
                                onClick: _withModifiers(($event: any) => (deleteShopName(v.id, i)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_icon, {
                                onClick: _withModifiers(($event: any) => (toTop(i, v.id)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Upload)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_icon, {
                                onClick: _withModifiers(($event: any) => (updataDetail(v)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 512), [
                              [_vShow, !v.active]
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ]))
                    }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_el_button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (updataShow())),
                plain: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_33,
                  _hoisted_34
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(exportVideo, {
          exchange: exchange.value,
          detail: _unref(shop).detail,
          shop: _unref(shop),
          ref: (_value, _refs) => {
            _refs['exports'] = _value
            exports.value = _value
          },
          onUpProps: upProps
        }, null, 8, ["exchange", "detail", "shop"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_36, [
        _withDirectives(_createVNode(_component_el_button, {
          plain: "",
          onClick: exportAll
        }, {
          default: _withCtx(() => [
            _hoisted_37,
            _hoisted_38
          ]),
          _: 1
        }, 512), [
          [_vShow, checkboxAll.value]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: noExporyAll
          }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            plain: "",
            onClick: yesExporyAll
          }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, !checkboxAll.value]
        ])
      ], 512), [
        [_vShow, _unref(shop).videoArr.length]
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createVNode(_component_el_dialog, {
          modelValue: isChecked.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (isChecked.value = $event)),
          onClose: onCloseProp
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, "当前选中" + _toDisplayString(checkAll.value?.length) + "条视频，是否确认导出？", 1),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_el_button, { onClick: directExport }, {
                default: _withCtx(() => [
                  _hoisted_43
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: mateExport }, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: noExport }, {
                default: _withCtx(() => [
                  _hoisted_45
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_46, [
      _createTextVNode(_toDisplayString(checkAll.value.length) + "/ ", 1),
      _createElementVNode("span", null, _toDisplayString(_unref(shop).videoArr.length), 1)
    ], 512), [
      [_vShow, !checkboxAll.value]
    ])
  ], 64))
}
}

})